import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from "firebase/firestore";
import { db } from "../../config/firebase-config";
import useColection from "../colection";
import { useCallback, useContext, useState } from "react";
import { UserContext } from "../../context";

const useWorker = () => {
  const { get, uploadPhoto, savePhotoUrl, ...others } =
    useColection<UserWorker>("workers");

  const userWorker = useContext(UserContext);

  const [workers, setWorkers] = useState<UserWorker[]>([]);
  const [workersWithLocation, setWorkersWithLocation] = useState<UserWorker[]>(
    []
  );

  const getWorkers = () => {
    return get([where("companyId", "==", userWorker.user?.companyId)]);
  };

  const uploadLogo = async (userId: string, file: File) => {
    const logoUrl = await uploadPhoto(userId, file);
    savePhotoUrl(userId, { photo: logoUrl });
  };

  const featWorkersList = useCallback(() => {
    const fn = async () => {
      const resp = await get();
      setWorkers(resp);
      setWorkersWithLocation(
        resp.filter(
          (workers) =>
            workers.currentLatitude !== undefined &&
            workers.currentLongitude !== undefined
        )
      );
    };
    fn();
  }, []);
  return {
    ...others,
    get: getWorkers,
    uploadPhoto: uploadLogo,
    featWorkersList,
    workers,
    workersWithLocation,
  };
};

export default useWorker;
